import { render } from "./shopifyTozoho.vue?vue&type=template&id=5749dfad&scoped=true"
import script from "./shopifyTozoho.vue?vue&type=script&lang=js"
export * from "./shopifyTozoho.vue?vue&type=script&lang=js"

import "./shopifyTozoho.vue?vue&type=style&index=0&id=5749dfad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5749dfad"]])

export default __exports__